var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 104,
    viewBox: "0 0 101 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7009 5.41241C38.3122 6.36257 33.1635 8.36479 28.5487 11.3048C23.9339 14.2447 19.9433 18.0649 16.8049 22.547C13.6664 27.0292 11.4415 32.0857 10.2572 37.4277C9.0729 42.7698 8.95239 48.2928 9.90255 53.6814C10.8527 59.07 12.8549 64.2187 15.7949 68.8336C18.7349 73.4484 22.555 77.4389 27.0372 80.5774C31.5194 83.7159 36.5758 85.9408 41.9179 87.1251C47.2599 88.3094 52.7829 88.4299 58.1715 87.4797C63.5602 86.5296 68.7089 84.5273 73.3237 81.5874C77.9385 78.6474 81.9291 74.8273 85.0675 70.3451C88.206 65.8629 90.4309 60.8064 91.6152 55.4644C92.7995 50.1223 92.92 44.5993 91.9699 39.2107C91.0197 33.8221 89.0175 28.6734 86.0775 24.0586C83.1375 19.4438 79.3174 15.4532 74.8352 12.3147C70.353 9.17626 65.2966 6.95137 59.9545 5.76706C54.6125 4.58276 49.0895 4.46225 43.7009 5.41241L43.7009 5.41241Z",
    stroke: "#FF6019",
    strokeWidth: 8.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2573 36.8414L65.2573 36.8781",
    stroke: "#FF6019",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6338 36.8826L35.6338 36.8369",
    stroke: "#FF6019",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.687,
    y: 49.3732,
    width: 21.1826,
    height: 15.5017,
    rx: 7.75085,
    transform: "rotate(90 58.687 49.3732)",
    fill: "#FF6019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOho);
export default __webpack_public_path__ + "static/media/infoOho.3103814b.svg";
export { ForwardRef as ReactComponent };